import React from 'react';
import { Badge } from '@/components/ui/badge';
import {
  getLinkedInOutboxSubtypeLabel,
  isLinkedInChannelDebugEnabled,
  isLinkedInOutboxChannel,
  logLinkedInChannelResolution,
} from '@/lib/outboxChannel';

/** Badge for LinkedIn DM vs connection request (Outbox, DIY steps, playbook preview). */
export default function LinkedInSubtypeBadge({ source, className = '', debugContext = '' }) {
  const label = getLinkedInOutboxSubtypeLabel(source);
  if (
    isLinkedInChannelDebugEnabled() &&
    isLinkedInOutboxChannel(source) &&
    !label &&
    debugContext
  ) {
    logLinkedInChannelResolution(`LinkedInSubtypeBadge:no-label:${debugContext}`, source);
  }
  if (!label) return null;
  return (
    <Badge
      variant="outline"
      className={`text-[10px] md:text-xs px-1.5 py-0.5 border-[#0077B5] text-[#0077B5] bg-[#0077B5]/5 font-medium whitespace-nowrap ${className}`}
    >
      {label}
    </Badge>
  );
}
